export const classes = {
  card: 'px-0 py-0 mt-4',
  ordersList: 'w-full max-h-[800px] py-0',
};
